import { render } from "./NoahAuraInfo.vue?vue&type=template&id=307ba8d6&scoped=true"
import script from "./NoahAuraInfo.vue?vue&type=script&lang=js"
export * from "./NoahAuraInfo.vue?vue&type=script&lang=js"

import "./NoahAuraInfo.vue?vue&type=style&index=0&id=307ba8d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307ba8d6"]])

export default __exports__